import QuickBookLogo from "./../../assets/images/quickbooks.png";
import MyobLogo from "./../../assets/images/MYOB_Logo.png";
import ReckonLogo from "./../../assets/images/Reckon_Logo-1.png";
import XeroLogo from "./../../assets/images/xero-logo.png";

import XEROLOGO from "./../../assets/images/software-logo/xero-logo.png";
import QUICKBOOKS from "./../../assets/images/software-logo/QB_logo.png";
import MYOB from "./../../assets/images/software-logo/MYOB_Logo.png";
import RECKON from "./../../assets/images/software-logo/Reckon_Logo-1.png";
import {
  ACCOUNTINGSOFTLOGO_SIZE,
  MYOBLOGO_WIDTH,
  QUICKBOOKLOGO_HEIGHT,
  QUICKBOOKLOGO_WIDTH
} from "./appConstants";

export const accountingSoftwareConfig = (hooks, labels) => [
  {
    id: "xero",
    type: "modal",
    logo: XeroLogo,
    icon: XEROLOGO,
    name: "Xero",
    alt: labels.xeroLogo,
    width: ACCOUNTINGSOFTLOGO_SIZE,
    height: ACCOUNTINGSOFTLOGO_SIZE
  },
  {
    id: "quickbooks",
    type: "redirect",
    logo: QuickBookLogo,
    icon: QUICKBOOKS,
    name: "QuickBooks",
    alt: labels.quickBookLogo,
    width: QUICKBOOKLOGO_WIDTH,
    height: QUICKBOOKLOGO_HEIGHT,
    authorizeFn: hooks.quickbooks.QuickBooksAuthorize,
    redirectKey: "data.data.authorizationUrl"
  },
  {
    id: "myob",
    type: "redirect",
    logo: MyobLogo,
    icon: MYOB,
    name: "MYOB",
    alt: labels.myobLogo,
    width: MYOBLOGO_WIDTH,
    height: ACCOUNTINGSOFTLOGO_SIZE,
    authorizeFn: hooks.myob.MyobAuthorize,
    redirectKey: "data.data"
  },
  {
    id: "reckon",
    type: "redirect",
    logo: ReckonLogo,
    icon: RECKON,
    name: "Reckon",
    alt: labels.reckonLogo,
    width: ACCOUNTINGSOFTLOGO_SIZE,
    height: ACCOUNTINGSOFTLOGO_SIZE,
    authorizeFn: hooks.reckon.ReckonAuthorize,
    redirectKey: "data.data.authenticationUrl"
  }
];

export const filterAccountingSoftware = (config, softwareName) => {
  if (!softwareName) return config;

  const safeOnlyShow = String(softwareName).toLowerCase();

  return config.filter((item) => {
    const itemName = item?.name || item?.title || item?.id || "";
    return itemName.toLowerCase() === safeOnlyShow;
  });
};
